export const data = [
   
    {
        id: 1,
        "title": "Rentola",
        "desc": "I have crafted Design on FIGMA with user flow, wireframes and prototypes for mobile application. This is a online house or flats seaerching based on application",
        "tech": "Figma, Font-awesome, Icons8 ",
        "img": "../../assets/rentola.png",
        "gitLink": "https://www.behance.net/gallery/206412467/House-Rental-Application ",
        "liveLink": "https://www.behance.net/gallery/206412467/House-Rental-Application ",
        "date": "Aug 2024",

    },
    {
        id: 1,
        "title": "Ecommerce Application",
        "desc": "I have created an E-commerce Application where user can browse products add them in cart, compatible with Laptop, Tab, Mobile. Compatible with desktop, iPad, mobile all devices.",
        "tech": "React.js,JavaScript,Redux,Css ",
        "img": "../../assets/wagon.png",
        "gitLink": "https://github.com/divs94/wagon ",
        "liveLink": "https://wagon-fashions-divs94.vercel.app/ ",
        "date": "July 2021– Aug 2021",

    },

    {
        id: 2,
        "title": "CartX Store",
        "desc": "This is a simple Landing page for watch store Where User can view The Desktop and Mobile version of this web page",
        "tech": " React.js , Css ",
        "img": "../../assets/cartx.png",
        "gitLink": "https://github.com/divs94/cartx",
        "liveLink": "https://cartx-mauve.vercel.app/ ",
        "date": "July 2021– Aug 2021",

    },
    {
        id: 3,
        "title": "The Great RGB Color Game",
        "desc": "It's an RGB color game project with three ( Easy, Medium, Hard modes created by me. through to this game user can improve their RGB color understanding skills. It helps them to use colors while developing websites or games. Compatible with desktop, iPad, mobile all devices. ",
        "tech": " HTML5 , Css, JavaScript. ",
        "img": "../../assets/rgb.svg",
        "gitLink": "https://github.com/divs94/Color-Grame",
        "liveLink": "https://divs94.github.io/Color-Grame/ ",
        "date": "July 2021– Aug 2021",


    },
    {
        id: 4,
        "title": "Charts with React.js",
        "desc": "This is a Chart integrated web application, where i have integrated charts using apex.js chart library of React.js",
        "tech": " React.js , Css ",
        "img": "../../assets/chart.png",
        "gitLink": "https://github.com/divs94/Chart-App",
        "liveLink": "https://chart-app-wheat.vercel.app/ ",
        "date": "July 2021– Aug 2021",
    },
    {
        id: 5,
        "title": "Divya's Portfolio",
        "desc": "This is my portfolio in dark theme created with react.js ",
        "tech": " React.js , Css, javaScript, Material UI ",
        "img": "../../assets/portfolio.png",
        "gitLink": "https://github.com/divs94/portfolio-divya",
        "liveLink": "https://portfolio-divya.vercel.app/ ",
        "date": "July 2021– Aug 2021",
    },
    {
        id: 6,
        "title": "Koffee Web App",
        "desc": "This is an online koffe restaurant wordpress web application. Which is usefull for selling coffee online. Built with wordpress templates.. ",
        "tech": " Wordpress ",
        "img": "../../assets/koffee.png",
        "gitLink": "",
        "liveLink": "https://koffe08.wordpress.com/ ",
        "date": "March 2024",
    },
    {
        id: 7,
        "title": "Suraksha Ai",
        "desc": "This web application claims solution to the problem is to convert citizens to public police, adopt a crowdsourcing approach and leverage the power of GenAI to record such traffic violations, report to authorities and reward responsible citizens... ",
        "tech": " HTML/CSS/Bootstrap ",
        "img": "../../assets/saImg.png",
        "gitLink": "https://github.com/divs94/surakshaAi",
        "liveLink": "https://suraksha.ai/ ",
        "date": "April 2024",
    },
    {
        id: 7,
        "title": "MotoZee",
        "desc": "This is a web application build on salesforce LWC component & live on community & on Netlify.. ",
        "tech": " LWC templates/ SLDS UI library/ Css ",
        "img": "../../assets/motozee.png",
        "gitLink": "https://vanshivtechnologiespvtltd66-dev-ed.develop.my.site.com/s/ ",
        "liveLink": "https://motozee.netlify.app/",
        "date": "May 2024",
    },
    {
        id: 8,
        "title": "Arcadia",
        "desc": "This is an art gallery web application build on Next.js technology. ",
        "tech": " Next.js/ React-bootstrap library/ Css ",
        "img": "../../assets/arcadia.svg",
        "gitLink": "",
        "liveLink": "https://arcadivs.vercel.app/",
        "date": "May 2024",
    },
];

export const contactData = [
    {
        id: 1,
        "title": "Linkedin ",
        "link": "https://www.linkedin.com/in/divyatailang ",
        "variant": "info",
    },
    {
        id: 2,
        "title": "Dribble ",
        "link": "https://dribbble.com/iam_divs ",
        "variant": "warning",
    },
    {
        id: 3,
        "title": "Behance ",
        "link": "https://www.behance.net/divyatailang ",
        "variant": "danger",

    },
    {
        id: 4,
        "title": "Github ",
        "link": "https://github.com/divs94 ",
        "variant": "primary",

    },
    {
        id: 5,
        "title": "Figma ",
        "link": "https://www.figma.com/@iam_divs ",
        "variant": "success",

    },

];

export const serviceData = [
  {
    id: 1,
    title: "Modern UI/UX Design",
  },
  {
    id: 2,
    title: "Responsive Website Design",
  },
  {
    id: 3,
    title: "Wireframing & Prototyping",
  },
  {
    id: 4,
    title: "Figma & Adobe XD Expertise",
  },
  {
    id: 5,
    title: "React.js & Frontend Development",
  },
  {
    id: 6,
    title: "Website Redesign & Optimization",
  }
]

export const carouselItems = [
    {
        id: 1,
        name: "Susan Falola",
        role: "JUUBIX Founder/CEO | Top 100 Global Women of the Future 2023",
        image: "../../assets/susan.jpg",
        text: "I had the pleasant experience of meeting Divya on our JUUBIX Global Techsprint Leadership Program GTLP where she participated as a UI/UX designer (2022/23). Led design development and excelled amongst her teammates because of her commitment and dynamic approach to teamwork, collaboration and new emerging technologies such as NFT's and Web3 Gaming. Starting as a participant, becoming lead designer for frontend, then innovative video content creator she has firmly established in the future of frontend design and technical leadership. I would recommend her and I can't wait to see where the future takes her.",
    },
    {
        id: 2,
        name: "Caleb Moses Hymele T.",
        role: "Software Developer",
        image: "../../assets/caleb.jpg",
        text: "Divya is exactly the sort of software developer any company would love. Her detail-oriented approach made her a pleasure to work with. We pair-programmed extensively together while working on various projects, and in that time her work ethic blew me away. Divya's design skill is just amazing, she views writing clean, accessible code as a calling, and she's great at identifying areas where we can improve UI. She's also super friendly; by the time our project was done, I felt like we'd known each other for years. If you need to get a job done simply and efficiently, Divya's definitely the person for you. I can't recommend her enough!.",
    },
    {
        id: 3,
        name: "Tooba Alvi",
        role: "Software Developer | Global Member @WomenTechNet",
        image: "../../assets/tooba.jpg",
        text: "Divya and I worked together in JUUBIX Tech Sprint Leadership program as part of the same design team.Divya has a creative mind that brings innovation in design themes and pull out the logical conclusion from it.Apart from being professional and punctual, she's really keen to work.It was such a great pleasure working with a friendly and cooperative person who was formerly a complete stranger!.",
    },
    {
        id: 4,
        name: "Siddharth Tewari",
        role: "UX Designer | Visual Designer",
        image: "../../assets/sid.jpg",
        text: "Divya is not just a coder; she's a strategic thinker who approaches challenges with a unique blend of creativity and analytical skills. Her attention to detail ensures the delivery of high-quality code, and she has an innate ability to navigate complex projects with ease. What sets Divya apart is not just her technical brilliance but also her collaborative spirit. She's a team player who readily shares insights and collaborates seamlessly with colleagues. I've witnessed her dedication to continuous learning, staying abreast of the latest industry trends and technologies!.",
    },
    {
        id: 5,
        name: "Diksha Jaiswal",
        role: "Co-Founder @BringOn",
        image: "../../assets/diksha.jpg",
        text: "I had the pleasure of working with Divya, an exceptionally talented designer with a keen eye for detail and creativity. Her ability to transform concepts into visually stunning designs is remarkable. Divya consistently delivers high-quality work, meets deadlines, and brings fresh ideas to the table. She is a true asset to any team!",
    },
    {
        id: 6,
        name: "Nikhil Sharma",
        role: "Software Engineer || Full Stack Developer",
        image: "../../assets/nikhil.jpg",
        text: "I had the pleasure of working with Divya, and I can confidently say she is a talented and dedicated professional. Her attention to detail, problem-solving skills, and ability to think creatively set her apart in any team. She consistently delivers high-quality work, meets deadlines efficiently, and collaborates seamlessly with colleagues. Her ability to transform ideas into effective solutions makes her a valuable asset. She is always proactive, ensuring that projects run smoothly while bringing fresh and innovative ideas to the table. I highly recommend Divya for any opportunity that comes her way. She would be a great addition to any team!",
    },
];

export const experienceData = [
  {
    id: 1,
    title: "INVIA Pvt. Ltd.",
    role: "UI/UX Designer",
    duration: "Oct 2024 – Present",
    location: "Noida (Onsite)",
    desc: "Designed intuitive mobile & web experiences for telecom SaaS products.",
    subDesc: "Created wireframes, prototypes, and UI systems using Figma.",
    tech: "Figma, HTML, CSS, JavaScript, AI Tools",
    link: "https://invia.com.au/",
  },
  {
    id: 2,
    title: "Vanshiv Technologies",
    role: "UI/UX Designer",
    duration: "Nov 2023 – Jun 2024",
    location: "Jaipur (Onsite)",
    desc: "Designed and developed responsive UI for web platforms.",
    subDesc: "Worked on API integrations and scalable UI components.",
    tech: "React, Next.js, Tailwind, TypeScript, Figma",
    link: "https://vanshiv.com/",
  },
  {
    id: 3,
    title: "Primus Learning",
    role: "UI/UX Designer (Freelance)",
    duration: "Sep 2023 – Nov 2023",
    location: "Remote",
    desc: "Designed UI for an E-learning platform.",
    subDesc: "Focused on usability and clean learning experience.",
    tech: "Figma",
    link: "https://primuslearning.io/",
  },
  {
    id: 4,
    title: "OaktreeConnect",
    role: "UI/UX Designer",
    duration: "Jul 2022 – Jun 2023",
    location: "UK / Bengaluru",
    desc: "Redesigned healthcare web platform for better UX.",
    subDesc: "Handled CMS, SEO improvements, and UI enhancements.",
    tech: "React, MUI, Strapi, Figma",
    link: "https://oaktreeconnect.co.uk/",
  },
  {
    id: 5,
    title: "JUUBIX LTD",
    role: "UI/UX + Frontend (Freelance)",
    duration: "Oct 2021 – May 2022",
    location: "Remote",
    desc: "Worked on alpha version of SaaS platform.",
    subDesc: "Handled UI design and frontend implementation.",
    tech: "React, JavaScript, Figma",
    link: "https://juubix.com/",
  },
  {
    id: 6,
    title: "Search N Play",
    role: "UI/UX Designer",
    duration: "Jan 2021 – Feb 2022",
    location: "Jaipur (Remote)",
    desc: "Designed websites and marketing-focused UI.",
    subDesc: "Worked on SEO-friendly layouts and visuals.",
    tech: "HTML, CSS, React, Figma",
    link: "https://www.searchnplays.com/",
  },
  {
    id: 7,
    title: "OSSTF Technologies",
    role: "UI/UX Designer",
    duration: "Apr 2022 – Jun 2022",
    location: "Remote",
    desc: "Designed mobile and web applications.",
    subDesc: "Focused on clean UI and usability.",
    tech: "Figma, Adobe XD",
    link: "https://osstftech.com/",
  },
  {
    id: 8,
    title: "Daily Hunt",
    role: "Content Curator",
    duration: "Dec 2019 – Feb 2021",
    location: "Bengaluru",
    desc: "Managed and optimized content for platform growth.",
    subDesc: "Improved engagement through content curation.",
    tech: "Content Optimization",
    link: "https://m.dailyhunt.in/",
  },
];
export const figmaData = [
    {
        id:1,
        title:" ",
        imgUrl :" ",
    }
]

export const aiTools = [
  {
    name: "ChatGPT",
    desc: "AI assistant for content & coding",
    logo: "../../assets/chatgpt.png",
  },
  {
    name: "Claude",
    desc: "AI for writing & reasoning",
    logo: "../../assets/claude.svg",
  },

  {
    name: "Figma AI",
    desc: "AI-powered UI design",
    logo: "../../assets/figma-logo.png",
  },
  {
    name: "Canva AI",
    desc: "Quick visual creation",
    logo: "../../assets/canva.webp",
  },
  {
    name: "Lovable",
    desc: "AI product prototyping",
    logo: "../../assets/lovable-logo.png",
  },
];


export const featuredProjects = [

  {
    id: 1,
    title: " PayMechanic",
    category: " Mobile Application | Figma",
    desc:"A fintech platform to manage vehicle services + payments in one place.",
    image: "../../assets/ftr2.png",
    link: "https://dribbble.com/shots/27346524-PayMechenic-A-Fintech-App?utm_source=Clipboard_Shot&utm_campaign=iam_divs&utm_content=PayMechenic%20(A%20Fintech%20App)&utm_medium=Social_Share&utm_source=Clipboard_Shot&utm_campaign=iam_divs&utm_content=PayMechenic%20(A%20Fintech%20App)&utm_medium=Social_Share"
  },
  {
    id: 2,
    title: "QUOTLY",
    category: "Mobile App | Figma",
    desc:"Quotly | A quote publishing mobile application.",
    image: "../../assets/ftr3.png",
    link: "https://www.figma.com/community/file/1541073587118013246/quotly-a-quote-publishing-mobile-app"
  },
  {
    id: 3,
    title: "DroneExe",
    category: "Mission Planner UI/UX | Figma",
    desc:"A smart drone control dashboard for planning, tracking, and managing drone missions with real-time monitoring and live controls.",
    image: "../../assets/ftr1.png",
    link: ""
  }

];